module.exports = __webpack_public_path__ + "static/media/finkraftLogo.11652303.svg";